/*
 * @Description: 门户--预览展示页
 */
import { RouteRecordRaw } from 'vue-router'
import LayoutPage from '@/layout/pcPortal.vue'
const pageDesignRouter: Array<RouteRecordRaw> = [
    {
        path: '/portalPage',
        component: LayoutPage,
        redirect: '/portalPage/Home',
        children: [
            {
                path: 'Home',
                component: () => import(/* webpackChunkName: "PortalHome" */ '@/views/portalPage/Home/index.vue'),
                name: 'PortalHome',
                meta: { title: '首页' }
            }, {
                path: 'CoursePlaza',
                component: () => import(/* webpackChunkName: "PortalCoursePlaza" */ '@/views/portalPage/CoursePlaza/index.vue'),
                name: 'PortalCoursePlaza',
                meta: { title: '课程广场' }
            }, {
                path: 'CourseDetail',
                component: () => import(/* webpackChunkName: "PortalCourseDetail" */ '@/views/portalPage/CourseDetail/index.vue'),
                name: 'PortalCourseDetail',
                meta: { title: '课程详情' }
            }, {
                path: 'AllArticle',
                component: () => import(/* webpackChunkName: "PortalAllArticle" */ '@/views/portalPage/AllArticle/index.vue'),
                name: 'PortalAllArticle',
                meta: { title: '所有文章' }
            }, {
                path: 'ArticleDetail',
                component: () => import(/* webpackChunkName: "PortalArticleDetail" */ '@/views/portalPage/ArticleDetail/index.vue'),
                name: 'PortalArticleDetail',
                meta: { title: '文章详情' }
            }
        ]
    }
]

export default pageDesignRouter
